class YGScriptLoader extends HTMLElement {
	loadScript(url, fn) {
        if(url){
            let loadScript = document.createElement('script')
            loadScript.src = url
            document.body.appendChild(loadScript)
    
            loadScript.onload = () => {
                fn()
            }
            
            loadScript.onerror = () => {
                console.error('Script load error')
            }
        }
	}

    // art-template 渲染Dom元素
    loadArtTemplate(templateID,HTMLClass,data) {
        // templateID: art-template模板ID
        // HTMLClass: 渲染的HTML元素类名
        // data: 渲染的数据

        let html = template(templateID, data);
        document.getElementById(HTMLClass).innerHTML = html;

        let handler = {
            set(target, key, value) {
                // 更新属性的值
                target[key] = value;
                // 更新页面
                let html = template(templateID, data);
                document.getElementById(HTMLClass).innerHTML = html;
              return true;
            }
        };
        
        let proxiedData = new Proxy(data, handler);
        
        return proxiedData
    }

    // 公共方法替换图片
    toggleImage(imageClass,radioID,objTitle,text) {
        let image = this.querySelector(imageClass)
    
        let radioList = this.querySelector(radioID).querySelectorAll(".yg-doll-radio")
        
        radioList.forEach((radio)=>{
            if(radio.checked){
                //获取到当前选项的图片数据
                image.src = radio.getAttribute("data-image")
                if(text == "none" || !text){
                    YGArtTemplate.orderNote[objTitle] = ''
                }else{
                    YGArtTemplate.orderNote[objTitle] = text + `(${radio.value})` 
                } 
            }
            //监听body选项的变化行为
            radio.addEventListener("change",function(e){
                //获取到改变后的图片
                image.src = e.target.getAttribute("data-image")

                if(text == "none" || !text){
                    YGArtTemplate.orderNote[objTitle] = ''
                }else{
                    YGArtTemplate.orderNote[objTitle] = text + `(${radio.value})` 
                }
                    
            })
        })
    }

    // 将输入的文本放置到图片预览
    addImageText(text){
        let addTextBox = this.querySelector('.yg-image-add-text-box')
        let addText = this.querySelector('.yg-image-add-text')
        let fontSize = 100
        
        addText.innerHTML = text
        
        YGArtTemplate.textObj.text = text
        do {
          fontSize--;
          YGArtTemplate.textObj.fontSize = fontSize + 'px'
          addText.style.fontSize = fontSize + 'px';
        } while (addText.offsetWidth > addTextBox.offsetWidth || addText.offsetHeight > addTextBox.offsetHeight);
    }

    // 更新文本框位置
    undataOffset(checkedItem){
        let addTextBox = this.querySelector('.yg-image-add-text-box')
        let imageBoxWidth = this.querySelector('.yg-image-list').offsetWidth
        let imageBoxHeight = this.querySelector('.yg-image-list').offsetHeight

        addTextBox.style.left = `${checkedItem.getAttribute('data-offset-x')}%`
        addTextBox.style.top = `${checkedItem.getAttribute('data-offset-y')}%`
        addTextBox.style.height = `${checkedItem.getAttribute('data-height')}%`
        addTextBox.style.width = `${checkedItem.getAttribute('data-width')}%`

        YGArtTemplate.textObj.x = checkedItem.getAttribute('data-offset-x') / 100 * imageBoxWidth
        YGArtTemplate.textObj.y = (checkedItem.getAttribute('data-offset-y') * 1 + checkedItem.getAttribute('data-height') * 1) / 100 * imageBoxHeight

    }

    // 筛选当前匹配的数据
    filterData(data,templateID,htmlID) {
        // data: 数据表
        // templateID: art-template模板ID
        // htmlID: 需要渲染的DOM元素

        // 获取到当前体型选项和脸部选项
        let dollBody = YGArtTemplate.bodyValue
        let dollBodyLength = YGArtTemplate.bodyLengthValue
        let dollExpression = YGArtTemplate.expressionValue
        
        // 匹配相对应的裙子数据
        let filterData = data
        filterData = Object.keys(filterData).filter(key => {
            // 判断表情是否为空
            if(!filterData[key].which_expression){
                // 返回匹配体型的裙子数据
                filterData[key].handle = htmlID
                return filterData[key].which_doll_body.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') == dollBody && filterData[key].which_doll_length == dollBodyLength
            } else {
                // 返回匹配体型和表情的裙子数据
                return filterData[key].which_doll_body.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') == dollBody && filterData[key].which_doll_length == dollBodyLength && filterData[key].which_expression.includes(dollExpression)
            }   
        }).map(key => filterData[key])

        
        let newFilterData = {'filterData': filterData}
        //更新数据
        newFilterData = this.loadArtTemplate(templateID,htmlID,newFilterData)
        return newFilterData
    }

    // 更新颜色
    undateColor(filterData,checkedValue,templateID,htmlID,priceBox) {
        // filterData: 过滤后的数据
        // checkedValue: 选中的值
        // templateID: art-template模板ID
        // htmlID: 需要渲染的DOM元素
        let totalPriceList = this.querySelectorAll('.yg-total-prices')

        if(checkedValue == "none") {
            if(priceBox && this.querySelector(`.${priceBox}`)){
                YGArtTemplate.priceObj[htmlID] = 0
                this.querySelector(`.${priceBox}`).innerText = '0'

                totalPriceList.forEach(totalPrice => {
                  totalPrice.innerHTML = ` $${this.undataPrice()}`
                })
                
            }
            return
        }

        // 检查是否有嵌套
        filterData = filterData.filterData ? filterData.filterData : filterData

        let filterColorData = Object.keys(filterData).filter(key => {
            filterData[key].handle = htmlID
            return filterData[key].name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') == checkedValue.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
        }).map(key => filterData[key])

        YGArtTemplate.priceObj[htmlID] = filterColorData[0].price ? filterColorData[0].price : 0
        
        if(priceBox && this.querySelector(`.${priceBox}`)){
            this.querySelector(`.${priceBox}`).innerText = `$${filterColorData[0].price}`
        }
        
        totalPriceList.forEach(totalPrice => {
          totalPrice.innerHTML = ` $${this.undataPrice()}`
        })
        
        return this.loadArtTemplate(templateID,htmlID,filterColorData[0])
    }

    undataPrice(){
        let price = 0;
        for (let key in YGArtTemplate.priceObj) {
            if (typeof parseFloat(YGArtTemplate.priceObj[key]) === 'number') {
                price += parseFloat(YGArtTemplate.priceObj[key])
            }
        }

        // 获取到刻字输入框是否填入内容
        let addTextInput = this.querySelector('.add-your-text')

        if (addTextInput.value.trim() !== '') {
            let textPrice = YGArtTemplate.customData.text_gift_card.price
            return price + parseFloat(textPrice);
        }
        return price;
    }

    // canvas合并图层
    async canvasImage(){
        const canvas = this.querySelector('.yg-canvas');
        const ctx = canvas.getContext('2d'); // 获取canvas的2d上下文
        const imgSources = [
        ];

        // let canvasWidth = this.querySelector('.yg-main-image').getBoundingClientRect().width
        let canvasWidth = 1024
        let canvasImages = this.querySelectorAll('.yg-main-image img')

        canvasImages.forEach((img, index) => {
            let computedStyle = window.getComputedStyle(img);
            let display = computedStyle.getPropertyValue('display');
            if (display != 'none') {
                imgSources.push(img.src)
                console.log(img.src);
            }
        })
        const imgElements = [];
        
        const promises = imgSources.map(function(src,index){
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = src+"?"+Date.now();
                img.onload = () => {
                    imgElements[index] = img;
                    console.log(img.src)
                    resolve();
                };
                img.onerror = (error) => {
                    reject(error);
                };
            });
        });

       let imageBase64 = Promise.all(promises)
            .then(() => {
                // canvas.width = imgElements[0].width;
                // canvas.height = imgElements[0].height;
                canvas.width = canvasWidth;
                canvas.height = canvasWidth;
    
                let drawPromise = Promise.resolve();
                imgElements.forEach((img, index) => {
                    drawPromise = drawPromise.then(() => {
                        return drawImageOnCanvas(img, 0, 0, canvasWidth, canvasWidth);
                    });
                });
    
                return drawPromise.then(() => {
                    // 判断是否输入文本
                    if(YGArtTemplate.textObj.text){
                        ctx.font = `400 ${YGArtTemplate.textObj.fontSize} ${YGArtTemplate.textObj.fontFamily}`;
                        ctx.fillStyle = `${YGArtTemplate.textObj.color}`; // 设置文本颜色
                        ctx.fillText(YGArtTemplate.textObj.text, YGArtTemplate.textObj.x, YGArtTemplate.textObj.y); // 在指定位置添加文本
                    }
                    
                    // this.requestProductData(this.undataPrice(), url)
                    window.YGImageBese64 = canvas.toDataURL();
                    return canvas.toDataURL();
                });


            })
            .catch((error) => {
                console.error('An error occurred while loading images: ', error);
            });

            function drawImageOnCanvas(image, x, y, width, height) {
                return new Promise((resolve, reject) => {
                    if (image.complete) {
                        ctx.drawImage(image, x, y, width, height);
                        resolve();
                    } else {
                        image.onload = () => {
                            ctx.drawImage(image, x, y, width, height);
                            resolve();
                        };
                        image.onerror = (error) => {
                            reject(error);
                        };
                    }
                });
            }

            return imageBase64
    }

    // 发送请求获取到产品数据
    requestProductData(price, image){
        const url = 'https://play.personalized-gift.com/personalized/api/product/customzation';
        const data = {
            title: 'Customized Product',
            price: price,
            image: image,
            domain: 'gloveleya-doll.myshopify.com'
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(result => {
            if (result.result === 'success') {
                const variantId = result.variant_id;
                // console.log('请求成功，变体ID: ', variantId);
                this.ygAddToCart(variantId)
            } else {
                const reason = result.reason || '未提供错误原因';
                console.log('请求失败。失败原因：', reason);
            }
        })
        .catch(error => {
            console.error('请求出现问题: ', error);
        });
    }

    ygAddToCart(variantID){
        if(YGArtTemplate.textObj.text){
            YGArtTemplate.orderNote["Text"] = YGArtTemplate.textObj.text;
            YGArtTemplate.orderNote["Text Font"] = YGArtTemplate.textObj.fontSize + " " + YGArtTemplate.textObj.fontFamily + "(" + YGArtTemplate.textObj.color + ")" ;
        }
        let message = document.querySelector('#add-your-message');
        if(message.value){
            YGArtTemplate.orderNote["Gift Card"] = document.querySelector('.yg-doll-radio[name="doll_gift_card"]:checked').value;
            YGArtTemplate.orderNote["Message"] = message.value;
        }

        let formData = {
            items: [
              {
                quantity: 1,
                id: variantID,
                properties: YGArtTemplate.orderNote
              }
            ]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            this.querySelector('.yg-add-button').classList.remove('yg-animation')
            let href = window.Shopify.routes.root + 'cart'
            window.location.href = href;
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
    }
}

class YGArtTemplate extends YGScriptLoader {
    // 获取到原始数据
    static Data = document.querySelector('.yg-data.hide-pc.hide-mobile')?.value;
    static customData = YGArtTemplate.Data? JSON.parse(YGArtTemplate.Data) :null;
    static dollBodyData = YGArtTemplate.customData? YGArtTemplate.customData.doll.doll_body: null;
    static dollExpressionData = YGArtTemplate.customData?YGArtTemplate.customData.doll.doll_expression: null;
    static dollHairData = YGArtTemplate.customData?YGArtTemplate.customData.product_hair: null;
    static dollSkirtData = YGArtTemplate.customData?YGArtTemplate.customData.product_skirt: null;
    static dollLeftHeaddressData = YGArtTemplate.customData?YGArtTemplate.customData.product_headdress.product_left_headdress: null
    static dollRightHeaddressData = YGArtTemplate.customData?YGArtTemplate.customData.product_headdress.product_right_headdress: null

    // 定义变量用来存储过滤后的数据避免修改到元数据
    static filterExpressionData = null
    static filterHairData = null
    static filterSkirtData = null
    static filterLetfHeaddressData = null
    static filterRightHeaddressData = null

    // 定义变量存储会影响到其他选项的结果
    static bodyValue = null;
    static bodyLengthValue = null;
    static expressionValue = null;
    static priceObj = {}
    static textObj = {}
    static orderNote = {}

    constructor() {
        super()
        this.init()
        const url = this.getAttribute('data-load-script')
        this.loadScript(url, () => {
            this.changeBody() // 调用自定义方法
        })
    }

    init() {
        this.toggleTag()
        this.changeText()
        this.initStyle()
        this.addToCart()
        this.togglePopup()
    }

    //切换娃娃定制Tag选项
    toggleTag() {
        let tabTitleList = this.querySelectorAll(".yg-tab")
        let tabContetnList = this.querySelectorAll(".yg-right-main-content>.yg-content")

        tabTitleList.forEach((tabTitle,index) => {
            tabTitle.addEventListener("click",function(){
                tabTitleList?.forEach((tabTitle) => {
                    tabTitle.classList.remove("active")
                })
                tabTitle.classList.add("active")
                tabContetnList?.forEach((tabContetn) => {
                    tabContetn.style.transform
                    tabContetn.style.transform = `translateX(-${index * 100}%)`
                })
            })
        });
    }

    // 切换Body选项
    changeBody() {
        let _this = this
        let bodyRadios = this.querySelectorAll('.yg-doll-radio[name="doll_body"]')
        bodyRadios.forEach((bodyRadio)=>{
            if(bodyRadio.checked){
                //获取到当前选项的数据
                YGArtTemplate.bodyValue = bodyRadio.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') 
                undateDollBody()
                this.changeBodyLength()
            }
            //监听body选项的变化行为
            bodyRadio.addEventListener("change",(e)=>{
                //获取到改变后的数据
                YGArtTemplate.bodyValue = e.target.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') 
                undateDollBody()
                this.changeBodyLength()    
            })
        })
        
        function undateDollBody() {
            //更新当前选项娃娃的长度以及颜色
            let dollBody = YGArtTemplate.dollBodyData[YGArtTemplate.bodyValue] 
            dollBody.handle = YGArtTemplate.bodyValue
            dollBody = _this.loadArtTemplate("doll-length-template","doll-body-length",dollBody)
        }
    }

    // 切换娃娃尺寸
    changeBodyLength() {
        let bodySelect = this.querySelector('#doll-body-length')
        console.log('123');

        bodySelect.addEventListener("change",()=>{
            YGArtTemplate.bodyLengthValue = bodySelect.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') 

            this.undateColor(YGArtTemplate.dollBodyData[YGArtTemplate.bodyValue].doll_length,YGArtTemplate.bodyLengthValue,"doll-color-template","doll-body-color","yg-body-price")
            this.toggleImage(".yg-doll-body-image","#doll-body-color","Body",`${YGArtTemplate.bodyValue} - ${YGArtTemplate.bodyLengthValue}`)
            // 获取到过滤后的表情数据并更新
            YGArtTemplate.filterExpressionData = this.filterData(YGArtTemplate.dollExpressionData,'doll-radio-template','doll-expression')
            this.changeExpression(YGArtTemplate.filterExpressionData)

            // 获取到过滤后的发型数据并更新
            YGArtTemplate.filterHairData = this.filterData(YGArtTemplate.dollHairData,"doll-radio-template","doll-hair")  
            this.changeHair(YGArtTemplate.filterHairData) 

            // 获取到过滤后的裙子数据并更新
            YGArtTemplate.filterSkirtData = this.filterData(YGArtTemplate.dollSkirtData,"doll-radio-template","doll-skirt")  
            this.changeSkirt(YGArtTemplate.filterSkirtData)

            // 获取到过滤后左头饰的数据并更新
            YGArtTemplate.filterLetfHeaddressData = this.filterData(YGArtTemplate.dollLeftHeaddressData,"doll-radio-template","doll-left-headdress")  
            this.changeLeftHeaddress(YGArtTemplate.filterLetfHeaddressData)

            // 获取到过滤后右头饰的数据并更新
            YGArtTemplate.filterRightHeaddressData = this.filterData(YGArtTemplate.dollRightHeaddressData,"doll-radio-template","doll-right-headdress")  
            this.changeRightHeaddress(YGArtTemplate.filterRightHeaddressData)  
            
        })   
        
        // 自执行一次change事件
        bodySelect.dispatchEvent(new Event("change"))
    }

    // 切换脸部表情选项
    changeExpression(filterData) {
        let bodyRadios = this.querySelectorAll('.yg-doll-radio[name="doll-expression"]')

        bodyRadios.forEach((bodyRadio)=>{
            //监听body选项的变化行为
            if(bodyRadio.checked){
                YGArtTemplate.expressionValue = bodyRadio.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
                this.undateColor(filterData,YGArtTemplate.expressionValue,"doll-color-template","doll-expression-color","yg-expression-price")
                this.toggleImage(".yg-doll-expression-image","#doll-expression-color","Expression",bodyRadio.value)   
            }
            bodyRadio.addEventListener("change",(e)=>{
                //获取到改变后的数据
                YGArtTemplate.expressionValue = e.target.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
                this.undateColor(filterData,YGArtTemplate.expressionValue,"doll-color-template","doll-expression-color","yg-expression-price")
                this.toggleImage(".yg-doll-expression-image","#doll-expression-color","Expression",bodyRadio.value)                   
            })
            // 自执行change事件
        })
    }

    // 切换发型选项
    changeHair(filterData){
        let bodyRadios = this.querySelectorAll('.yg-doll-radio[name="doll-hair"]')
        bodyRadios.forEach((bodyRadio)=>{
            //监听body选项的变化行为
            if(bodyRadio.checked){
                this.undateColor(filterData,bodyRadio.value,"doll-color-template","doll-hair-color","yg-hair-price")
                this.toggleImage(".yg-doll-hair-image","#doll-hair-color","Hair",bodyRadio.value)  
            }
            bodyRadio.addEventListener("change",(e)=>{
                //获取到改变后的数据
                this.undateColor(filterData,e.target.value,"doll-color-template","doll-hair-color","yg-hair-price")
                this.toggleImage(".yg-doll-hair-image","#doll-hair-color","Hair",bodyRadio.value)                   
            })
            // 自执行change事件
        })
    }

    // 切换裙子选项
    changeSkirt(filterData){
        let bodyRadios = this.querySelectorAll('.yg-doll-radio[name="doll-skirt"]')

        bodyRadios.forEach((bodyRadio)=>{
            //监听body选项的变化行为
            if(bodyRadio.checked){
                this.undateColor(filterData,bodyRadio.value,"doll-color-template","doll-skirt-color","yg-skirt-price") 
                this.toggleImage(".yg-doll-skirt-image","#doll-skirt-color","Skirt",bodyRadio.value) 

                //更新文本位置
                this.undataOffset(bodyRadio)
            }
            bodyRadio.addEventListener("change",(e)=>{
                //获取到改变后的数据
                this.undateColor(filterData,e.target.value,"doll-color-template","doll-skirt-color","yg-skirt-price") 
                this.toggleImage(".yg-doll-skirt-image","#doll-skirt-color","Skirt",bodyRadio.value) 
                
                //更新文本位置
                this.undataOffset(e.target)
            })
            // 自执行change事件
        })
    }

    // 切换左发饰选项
    changeLeftHeaddress(filterData){
        let bodyRadios = this.querySelectorAll('.yg-doll-radio[name="doll-left-headdress"]')
        bodyRadios.forEach((bodyRadio)=>{
            //监听body选项的变化行为
            if(bodyRadio.checked){
                this.undateColor(filterData,bodyRadio.value,"doll-color-template","doll-left-headdress-color","yg-left-headdress-price")
                this.toggleImage(".yg-doll-left-headdress-image","#doll-left-headdress-color","Left Headdress",bodyRadio.value) 
            }
            bodyRadio.addEventListener("change",(e)=>{
                //获取到改变后的数据
                this.undateColor(filterData,e.target.value,"doll-color-template","doll-left-headdress-color","yg-left-headdress-price")
                this.toggleImage(".yg-doll-left-headdress-image","#doll-left-headdress-color","Left Headdress",bodyRadio.value)                     
            })
        })
    }

    // 切换右发饰选项
    changeRightHeaddress(filterData){
        let bodyRadios = this.querySelectorAll('.yg-doll-radio[name="doll-right-headdress"]')
        bodyRadios.forEach((bodyRadio)=>{
            if(bodyRadio.checked){
                this.undateColor(filterData,bodyRadio.value,"doll-color-template","doll-right-headdress-color","yg-right-headdress-price")
                this.toggleImage(".yg-doll-right-headdress-image","#doll-right-headdress-color","Right Headdress",bodyRadio.value)     
            }
            //监听body选项的变化行为
            bodyRadio.addEventListener("change",(e)=>{
                //获取到改变后的数据
                this.undateColor(filterData,e.target.value,"doll-color-template","doll-right-headdress-color","yg-right-headdress-price")
                this.toggleImage(".yg-doll-right-headdress-image","#doll-right-headdress-color","Right Headdress",bodyRadio.value)                     
            })
        })
    }    

    // 监听刻字文本
    changeText(){
        let addTextBox = this.querySelector('.yg-image-add-text-box')
        let addTextInput = this.querySelector('.add-your-text')
        let textLength = this.querySelector('.yg-add-text .yg-text-length')
        let textPriceBox = this.querySelector('.yg-add-text-price')
        
        addTextInput.addEventListener("input",()=>{
            // 添加到预览图片实时预览
            this.addImageText(addTextInput.value)
            textLength.innerText = addTextInput.value.length

            // 更新价格
            
            if(textLength.innerText == '0'){
                textPriceBox.innerText = '0'
            }else{
                textPriceBox.innerText = `$${YGArtTemplate.customData.text_gift_card.price}`
            }
            
            let totalPriceList = this.querySelectorAll('.yg-total-prices')
            totalPriceList.forEach(totalPrice => {
              totalPrice.innerHTML = ` $${this.undataPrice()}`
            })
        })

        // 获取到字体选项以及颜色选项
        let familyData = this.querySelector('#doll-text-family')
        let textColorRadios = this.querySelectorAll('.yg-doll-radio[name="doll-text-color"]')
        let addText = this.querySelector('.yg-image-add-text')
        
        textColorRadios.forEach((colorRadio)=>{
            if(colorRadio.checked){
                addText.style.color = colorRadio.value
                YGArtTemplate.textObj.color = colorRadio.value
            }
            //监听body选项的变化行为
            colorRadio.addEventListener("change",(e)=>{
                //获取到改变后的数据
                addText.style.color = e.target.value
                YGArtTemplate.textObj.color = e.target.value
            }) 
        })

        familyData.addEventListener("change",(e)=>{
            addText.style.fontFamily = familyData.value
            YGArtTemplate.textObj.fontFamily = familyData.value
        })

        familyData.dispatchEvent(new Event("change"))

        let addMessage = this.querySelector('.add-your-message')
        let messageLength = this.querySelector('.yg-add-message .yg-text-length')

        addMessage.addEventListener("input",function(){
            messageLength.innerText = addMessage.value.length
        })
    }

    addToCart(){
        let addToCart = this.querySelector('.yg-add-button')

        addToCart.addEventListener("click",()=>{
            addToCart.classList.add('yg-animation')
            this.requestProductData(this.undataPrice(), window.YGImageBese64)
        })
    }

    togglePopup(){
      let $videoPopup = this.querySelector('.yg-popup-box')

      let $popupButton = this.querySelector('.yg-toggle-popup-button')
      let $popupImage = this.querySelector('.yg-popup-image')

      $popupButton.addEventListener("click",()=>{
        //打开弹框
        $popupButton.classList.add('yg-animation')
        this.canvasImage().then((value)=>{
          $popupImage.src = value
          openPopup()
          $popupButton.classList.remove('yg-animation')
        }).catch((error)=>{
          console.log("error",error);
        })     
      })

      //关闭弹框
      $videoPopup.addEventListener("click", (e) => {
        closePopup(e)
      })

      function openPopup(){
        document.querySelector('body').style.overflow = "hidden"
        $videoPopup.style.display = "flex"
      }

      function closePopup(e){
        if(e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box'){
          $videoPopup.style.display = "none"
          document.querySelector('body').style.overflow = "auto"
        }
      }
    }

    // 初始化样式
    initStyle (){
        window.addEventListener("resize",()=>{
            this.querySelector('.yg-right-content').style.height = `${this.querySelector('.yg-left-produtct').getBoundingClientRect().height}px`
        })
        window.dispatchEvent(new Event("resize"))
    }


}

if (!window.customElements.get('yg-art-template')) {
    window.customElements.define('yg-art-template',YGArtTemplate)
}